import { jsx } from "react/jsx-runtime";
import {
  themeable,
  useTheme,
  variableToString
} from "@tamagui/core";
import { YStack } from "@tamagui/stacks";
import * as React from "react";
import { ActivityIndicator } from "react-native";
const Spinner = YStack.extractable(
  themeable(
    React.forwardRef((props, ref) => {
      const { size, color: colorProp, ...stackProps } = props;
      const theme = useTheme();
      let color = colorProp;
      if (color && color[0] === "$") {
        color = variableToString(theme[color]);
      }
      return /* @__PURE__ */ jsx(YStack, { ref, ...stackProps, children: /* @__PURE__ */ jsx(ActivityIndicator, { size, color }) });
    }),
    {
      componentName: "Spinner"
    }
  )
);
export {
  Spinner
};
//# sourceMappingURL=Spinner.js.map
